import React, { useRef, useEffect, useState } from 'react';
import Link from '../Link';
import './index.scss';

const ProjectCard = ({ photo, project, category, clients, link }) => {
  const [ timer, setTimer ] = useState(null);

  const handleDrawLine = (e, status) => {
    const target = e.currentTarget;
    let myReq;
    function getPoints() {
      const wrap = target.getBoundingClientRect();
      const image = target.querySelector('.image').getBoundingClientRect();
      const x1 = (image.x - wrap.x) / wrap.width * 100;
      const y1 = (image.y - wrap.y) / wrap.height * 100;
      const x2 = x1 + (image.width / wrap.width * 100);
      const y2 = y1 + (image.height / wrap.height * 100);
      const points = [
        `0 0,    ${x1} ${y1}`,
        `0 100,  ${x1} ${y2}`,
        `100 0,  ${x2} ${y1}`,
        `100 100,${x2} ${y2}`,
      ];

      const polygons = target.querySelectorAll('polygon');
      polygons.forEach((polygon, i) => polygon.setAttribute('points', points[i]))

      if (status === true) {
        myReq = window.requestAnimationFrame(getPoints, 10);
        setTimer(myReq);
      }
      else {
        window.cancelAnimationFrame(timer);
        setTimer(timer);
      }
    }
    getPoints();
  }

  return (
    <div className="project-card">
      <Link to={link} className="cover card-cover"
        onMouseEnter={ (e) => handleDrawLine(e, true) }
        onMouseLeave={ (e) => handleDrawLine(e, false) }
        onClick={ (e) => handleDrawLine(e, false) }>
        <img className="image" src={ photo } />
        <svg className="frame" width='100%' height='100%' preserveAspectRatio="none" viewBox="0 0 100 100" >
          <rect x="0" y="0" width="100" height="100" />
          <polygon points="0 0" />
          <polygon points="0 0" />
          <polygon points="0 0" />
          <polygon points="0 0" />
        </svg>
      </Link>
      <div className="list dashed-table">
        <div className="item">
          <div className="label type-text -en -lg">PROJECT</div>
          <div className="content type-text -en -lg">{ project }</div>
        </div>
        <div className="item">
          <div className="label type-text -en -lg">CATEGORY</div>
          <div className="content type-text -en -lg">{ category }</div>
        </div>
        <div className="item">
          <div className="label type-text -en -lg">CLIENTS</div>
          <div className="content type-text -en -lg">{ clients }</div>
        </div>
      </div>
    </div>
  )
}

export default ProjectCard;